/**
 * Canonical category-page URL. Flat `/c/[slug]` — slugs are unique per brand
 * (P2-09 added the `@@unique([brandId, slug])` constraint), so a slug resolves
 * to exactly one category. Every nav/breadcrumb link routes through here.
 */
export function categoryHref(slug: string): string {
  return `/c/${slug}`;
}
